import React, { ReactNode } from "react";
import type { ValidSizes, ValidThemes } from '../../utils/types';

import themes from "../../styles/themes";

export type validWeights = "light" | "normal" | "medium" | "semibold" | "bold" | "extrabold" | "black"
export type validAlignment = "left" | "center" | "right"
export type validFonts = "inter" | "gilroy"

const alignmentClasses = {
  'left': 'text-left',
  'center': 'text-center',
  'right': 'text-right'
}

const sizeClasses = {
  '2xs': 'text-2xs',
  'xs': 'text-xs',
  'sm': 'text-sm',
  'md': 'text-md',
  'lg': 'text-lg',
  'xl': 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl',
  '4xl': 'text-4xl',
  '5xl': 'text-5xl',
}

const weightClasses = {
  'light': 'font-light',
  'normal': 'font-normal',
  'medium': 'font-medium',
  'semibold': 'font-semibold',
  'bold': 'font-bold',
  'extrabold': 'font-extrabold',
  'black': 'font-black',
}

const horizontalPaddingClasses = {
  '2xs': 'px-2xs',
  'xs': 'px-xs',
  'sm': 'px-sm',
  'md': 'px-md',
  'lg': 'px-lg',
  'xl': 'px-xl',
  '2xl': 'px-2xl',
  '3xl': 'px-3xl',
  '4xl': 'px-4xl',
  '5xl': 'px-5xl',
}

const fontFamilyClasses = {
  'inter': 'font-inter',
  'gilroy': 'font-gilroy'
}

export interface Props {
  children: ReactNode,
  size?: ValidSizes,
  fontFamily?: validFonts
  weight?: validWeights,
  alignText?: validAlignment,
  horizontalPadding?: ValidSizes | 0,
  theme?: ValidThemes
}

export const Text = (
  {
    children,
    size = 'md',
    fontFamily = 'inter',
    weight = 'normal',
    alignText = 'center',
    horizontalPadding = 0,
    theme = 'primary'
  }: Props
) => {
  const themeKey = theme as keyof typeof themes.textBlock;
  const themeClasses = themes.textBlock[themeKey]?.classes;
  const textClasses = `${alignmentClasses[alignText]} ${sizeClasses[size]} ${weightClasses[weight]} ${fontFamilyClasses[fontFamily]} [&_a]:underline [&_a]:cursor-pointer`;
  let paddingClasses = '';
  if (horizontalPadding != 0) {
    paddingClasses = `${horizontalPaddingClasses[horizontalPadding]}`;
  }
  
  return (
      <div
        className={`${paddingClasses} ${textClasses} ${themeClasses}`}>
          {children}
      </div>
  );
};

export default Text;